import React from "react";
import MlinvoiceManagementTable from "../../components/table/all-tables/mlinvoicemanagtable/MlinvoiceManagementTable";
import TablePagesTitle from "../../components/table-pages-title/TablePagesTitle";
import ReportPageAction from "../reports/page-action/ReportPageAction";
import Style from "./../../assets/scss/custom.module.scss";

export default function MlinvoiceManagement() {
  return (
    <>
      <TablePagesTitle mainTitle="Ml Invoice management" />

      <ReportPageAction subheading="Ml Invoice list" />

      <div className="row mx-0 mt-3">
        <div
          className={`${Style.tabContainerCustom} tabcontainercustom col-md-12 `}
        >
          <MlinvoiceManagementTable />
        </div>
      </div>
    </>
  );
}
